import React, { Fragment, useState, useContext, useEffect, Link } from 'react';
import {
    Paper,
    Grid,
    TextField,
    Select,
    MenuItem,
    Button,
    Typography,
    Dialog,
    DialogContent,
} from '@material-ui/core';
import { useStyles } from '../styles/Styles';
import 'date-fns';
import DocumentUploadContext from '../context/DocumentUpload/documentUploadContext';
import NotificationContext from '../context/Notification/notificationContext';
import OTP from '../components/OTP/OTP';
import Notification from '../components/notification/Notification';
import Spinner from '../components/spinner/Spinner';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import NumberFormat from 'react-number-format';
import DateFnsUtils from '@date-io/date-fns';
import Header from '../components/header/Header';

const SelectSchedule = () => {
    const classes = useStyles(); //Use Styles from styles/styles.js
    const documentUploadContext = useContext(DocumentUploadContext); //Use documentUploadContext from context/DocumentUploadContext
    const {
        userInfo,
        setUserInfo,
        errors,
        clearErrors,
        loading,
        CheckifSoftLock,
        getApplicationDetails,
        applicationDetails,
        requestForOTP,
        otp_succ,
        otpRequest,
        getVideoCallSchedule,
        videoCallSchedule,
        setVideoCallSchedule,
        setDisplayVideoCallSchedule
    } = documentUploadContext;

    const [dateTimeVideoCall, setDateTimeVideoCall] = useState('');

    const onDateTimeVideoCallChange = (e) => setDateTimeVideoCall(e.target.value);

    const handleSubmitClick = (e) => {
        if (videoCallSchedule !== null)
        {
            setVideoCallSchedule(dateTimeVideoCall);
            setDisplayVideoCallSchedule(
                videoCallSchedule.filter(m => m.schedule.includes(dateTimeVideoCall))[0].displaySchedule
            );
        }
    };

    useEffect(() => {
        getVideoCallSchedule();
       
    }, [userInfo, errors]);

    return (
        <div>
            <Header page={3} />
            <div className={classes.banner}>
                <Fragment>
                    <Typography className={classes.paragraph}>Thank you for applying for a PSBank Savings Account through the PSBank Mobile App. In order to complete your application, please schedule a video call with us by selecting your preferred date and time.</Typography>
                    <Paper elevation={0} className={classes.paper}>
                        <Notification />
                        {loading ? (
                            <Spinner />
                        ) : (
                                <Fragment>
                                    <Grid container spacing={3} justify='center' alignItems='center' >
                                        <Grid item md={6} xs={12}>
                                            <p classes={classes.txtFldLbl}>Date and Time of Video Call</p>
                                            <Select
                                                native
                                                className={classes.txtField}
                                                value={dateTimeVideoCall}
                                                onChange={onDateTimeVideoCallChange}
                                                variant='outlined'
                                                inputProps={{
                                                    name: "age",
                                                    id: "outlined-age-native-simple"
                                                }}
                                            >
                            ))}
                            <option value="" disabled>
                Select a schedule
                </option>
                            { videoCallSchedule !== null ? videoCallSchedule.map((item) => (
                                <option key={item.schedule} value={item.schedule}>
                                    {item.displaySchedule}
                        </option>
                            )) :  null}
                                            </Select>
                                        </Grid>
                                    </Grid>
                                    <Grid
                                        container
                                        spacing={8}
                                        direction='row'
                                        justify='center'
                                        alignItems='center'
                                    >
                                        {dateTimeVideoCall === '' ? ( //ADD OR SOFTLOCK
                                            <Grid item xs={8} sm={5} md={3} lg={3} xl={3}>
                                                <Button
                                                    style={{
                                                        textAlign: 'right',
                                                        textTransform: 'capitalize',
                                                        fontSize: '12px',
                                                        width: '100%',
                                                        marginTop: '1rem',
                                                    }}
                                                    variant='contained'
                                                    color='primary'
                                                    type='submit'
                                                    onClick={handleSubmitClick}
                                                    disabled
                                                >
                                                    Proceed
                        </Button>
                                            </Grid>
                                        ) : (
                                                <Grid item xs={8} sm={5} md={3} lg={3} xl={3}>
                                                    <Button
                                                        style={{ textAlign: 'right' }}
                                                        className={classes.button}
                                                        variant='contained'
                                                        color='primary'
                                                        type='submit'
                                                        onClick={handleSubmitClick}
                                                    >
                                                        Proceed
                        </Button>
                        
                                                </Grid>
                                            )}
                                    </Grid>
                                </Fragment>
                            )}
                    </Paper>
                </Fragment>
            </div>
        </div>
    );
};

export default SelectSchedule;
